<template>
  <div class="index information">
    <div class="information-container">
      <div class="centered add-document">
        <span class="button-wrapper link" @click="handleAddFinancialDocument">
          <a class="button is-info">+</a> Добавить документ
        </span>
      </div>
      <div class="documents" v-if="fDocuments.length">
        <div class="save-content-button centered">
          <button class="button save-content" @click="handleSaveFinancialDocuments()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
        </div>
        <table>
          <thead>
            <tr>
              <td>Документ</td>
              <td>Дата расчета</td>
              <td>Дата раскрытия</td>
              <td>Период актуальности информации</td>
              <td>Дата скрытия</td>
            </tr>
          </thead>
          <draggable class="fake-table" v-model="documentsData">
            <DocumentItem v-for="document in documentsData" :key="document.id" :document="document"/>
          </draggable>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentItem from 'components/Information/DocumentItem'
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import draggable from 'vuedraggable'
import uuidv4 from 'uuid/v4'

export default {
  name: 'InformationDocuments',
  data () {
    return {
      disabled: false
    }
  },
  computed: {
    ...mapState(['fDocuments']),
    documentsData: {
      get () {
        return deepcopy(this.fDocuments)
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.updateFinancialDocuments(val)
      }
    }
  },
  created () {
    this.getFinancialDocuments()
  },
  methods: {
    ...mapActions(['getFinancialDocuments', 'addFinancialDocument', 'saveFinancialDocuments',
      'getDocumentType', 'addDocumentType', 'updateFinancialDocuments']),
    handleAddFinancialDocument () {
      this.addFinancialDocument({
        id: uuidv4(),
        order: this.fDocuments.length
      })
    },
    handleSaveFinancialDocuments () {
      this.disabled = true
      this.saveFinancialDocuments(this.fDocuments)
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    }
  },
  components: { DocumentItem, draggable }
}
</script>

<style scoped>
.information-container {
  background: #eee;
  padding: 25px 15px 60px;
  margin: 15px 0 0;
}
.information {
  margin: 15px 0 0;
}
.documents {
  background: white;
  padding: 35px 40px 40px;
  max-width: 1368px;
  margin: 0 auto;
  min-width: 1074px;
}
.documents thead {
  color: darkgray;
  font-size: 14px;
}
.documents thead :not(:first-child) {
  padding-left: 10px;
}
.add-document {
  margin: 0 0 22px;
}
</style>



// WEBPACK FOOTER //
// Information.vue?f2a9b7d4